"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const Box_1 = require("./Box");
const ShieldIcon = (props) => {
    const svgStyle = Object.assign({ "position": "absolute", "top": "0", "right": "0", "bottom": "0", "left": "0", "width": "100%", "height": "100%" });
    return (React.createElement(Box_1.Box, Object.assign({ position: "relative", width: 18, height: 18 }, props),
        React.createElement("svg", { x: "0px", y: "0px", viewBox: "0 0 18 18", style: svgStyle, xmlSpace: "preserve", fill: "currentColor" },
            React.createElement("path", { d: "M9,2L3.5,4.1v4.2c0,1.8,0.5,3.4,1.5,4.9s2.3,2.5,4,2.9c1.6-0.4,2.9-1.4,4-2.9c1-1.5,1.5-3.1,1.5-4.9V4.1L9,2z M8.2,11.3 L5.8,8.8L6.6,8l1.7,1.8l3.1-3.2l0.7,0.7L8.2,11.3z" }))));
};
ShieldIcon.displayName = 'ShieldIcon';
exports.default = ShieldIcon;
//# sourceMappingURL=ShieldIcon.js.map